type IconProps = { className?: string };

export function IonosBrandIcon({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden>
      <rect width="24" height="24" rx="6" fill="#003D8F" />
      <path
        fill="#fff"
        d="M5.5 16.5V7.5h1.8l2.6 6.1 2.6-6.1h1.8v9h-1.7v-5.8l-2.4 5.8h-1l-2.4-5.8v5.8H5.5z"
      />
    </svg>
  );
}
